import { render, staticRenderFns } from "./ChatCheckbox.vue?vue&type=template&id=00fcf1c6&scoped=true"
import script from "./ChatCheckbox.vue?vue&type=script&lang=js"
export * from "./ChatCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ChatCheckbox.vue?vue&type=style&index=0&id=00fcf1c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fcf1c6",
  null
  
)

export default component.exports